import client from "./client/client";

export default async function call(
  requestType,
  url,
  data = null,
  options = {}
) {
  const config = {
    method: requestType,
    url,
    data,
    ...options,
  };
  return client.request(config);
}
